// Experiment setup
// 1. Experiment ID should be added to ExperimentIds.
// 2. Cohort should be named using values defined in ExperimentCohorts.

export enum ExperimentIds {
  aaTest = "parking_aa_test", // status: placeholder for testing
  keywordOptimizationWithAI = "parking_parkweb_ab_3393", // status: Inconclusive, cleanup?
  skenzoLander = "parking_cp_4283", // status: Not run
  airoBuilderBanner = "parking_pw_4849", // status: active - Airo AI Builder banner on Yahoo ParkWeb
  mobileAppAd = "parking_pw_4959_mobile_app", // status: active - Mobile app ad experiment for Yahoo ParkWeb (mobile US only)
  yahooOptimizedKeywords = "parking_5211_yahoo_optimized_keywords", // status: active (test) - PW high-value keywords via Yahoo Partner Supplied Terms (PARKING-5211)
  pwRollerAdsUS = "parking_5254_pw_rollerads_us", // status: active - RollerAds 1-click for US ParkWeb (PARKING-5254)
}

// Cohort to utm_campaign and google channel mapping:
//   * control, off ->
//       campaignID: x_dom-broker_parkedpages_x_x_invest_a_001
//       channel: +control
//   * treatment, pw_treatment, cp_treatment ->
//     campaignID: x_dom-broker_parkedpages_x_x_invest_b_001
//     channel: +treatment
//   * treatmentB, treatment_b  ->
//     campaignID: x_dom-broker_parkedpages_x_x_invest_b_001
//     channel: +treatmentB | +treatment_b
//
// Possible cohort names:
export enum ExperimentCohorts {
  control = "control",
  off = "off",
  treatment = "treatment",
  pw_treatment = "pw_treatment",
  cp_treatment = "cp_treatment",
  // Multi-cohort treatment names:
  // ** A is reserved for control cohort **
  treatmentB = "treatmentB",
  treatment_b = "treatment_b",
  treatmentC = "treatmentC",
  treatment_c = "treatment_c",
  treatmentD = "treatmentD",
  treatment_d = "treatment_d",
  treatmentE = "treatmentE",
  treatment_e = "treatment_e",
  // Add more cohorts as needed following above pattern
}
